// School-admin shell — SaaS-clean. Live in R9.

import type { ReactNode } from 'react';

import { SidebarShell, type NavEntry } from '../SidebarShell';

const NAV: NavEntry[] = [
  { to: '/$locale', labelKey: 'app.nav.overview', icon: '🏫' },
  { to: '/$locale/school/teachers', labelKey: 'app.nav.teachers', icon: '👩‍🏫' },
  { to: '/$locale/school/classes', labelKey: 'app.nav.classes', icon: '📚' },
  { to: '/$locale/school/students', labelKey: 'app.nav.students', icon: '🧑‍🎓' },
  { to: '/$locale/billing', labelKey: 'app.nav.billing', icon: '💳' },
];

export function SchoolAdminShell({ children }: { children: ReactNode }) {
  return (
    <SidebarShell titleKey="app.common.role_school_admin" nav={NAV}>
      {children}
    </SidebarShell>
  );
}
